import axios from "axios";
import { get } from "lodash";
import env from "@beam-australia/react-env";

import { TIME_OUT } from "../constants/app";

// @ts-ignore
const e = env();
const graphqlUrl = `${get(
  e,
  "REACT_APP_GRAPHQL_URI",
  "https://treelab-gateway-2fgufto4.develop.treelab.com.cn"
)}/graphql`;

export const postData = (body: string, token: string, sessionId: string) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        // `${
        //   process.env.REACT_APP_GRAPHQL_URI || "https://treelab-gateway-2fgufto4.develop.treelab.com.cn/graphql"
        // }/graphql`,
        // "https://treelab-gateway-2fgufto4.develop.treelab.com.cn/graphql",
        graphqlUrl,
        body,
        {
          headers: {
            "content-type": " application/json",
            authorization: `Bearer ${token}`,
            accept: "*/*",
            "cache-control": "max-age=0",
            "X-Treelab-Session-ID": `${sessionId}`,
          },
          timeout: TIME_OUT,
        }
      )
      .then((response) => {
        const {
          data: { data, errors },
        } = response;
        if (!errors) {
          resolve(data);
        } else {
          reject(errors);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};
